export const DEFAULT_MEMBER_ID = 9999999;

export function resolveMemberId(value) {
    if (value == null || value === '') {
        return DEFAULT_MEMBER_ID;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : DEFAULT_MEMBER_ID;
}

export function isDefaultMemberId(value) {
    if (value == null || value === '') {
        return true;
    }
    return String(value).trim() === String(DEFAULT_MEMBER_ID);
}

export function realMemberIdOrEmpty(value) {
    if (isDefaultMemberId(value)) {
        return '';
    }
    return String(value).trim();
}
